// Change these to your real URLs — one central place.
export const CTA = {
  hireUs: "https://tidycal.com/jayp/strategy-call",
  buyCoffee: "https://ko-fi.com/startwithjay",
};
